export default __webpack_public_path__ + "static/leaf-pattern-1d1fe7a85832c900d033e2d0c8f4814a.png";